import { useState, useCallback, useEffect } from "react";

const DEFAULT_COOL_DOWN_SECONDS = 5;

interface UseRefreshCooldownReturn {
  /** 残りクールダウン秒数。0 の場合はリフレッシュ可能 */
  coolDownTime: number;
  /** データ再取得とクールダウン開始を行うハンドラ */
  handleRefresh: () => void;
}

/**
 * 一覧画面の更新ボタン用クールダウンタイマー。
 * mutate を実行し、指定秒数のクールダウン期間を設けて連打を防止する。
 */
export const useRefreshCooldown = (
  mutate: () => void,
  coolDownSeconds: number = DEFAULT_COOL_DOWN_SECONDS
): UseRefreshCooldownReturn => {
  const [coolDownTime, setCoolDownTime] = useState(0);

  useEffect(() => {
    if (coolDownTime <= 0) return;
    const timerId = setTimeout(() => {
      setCoolDownTime(coolDownTime - 1);
    }, 1_000);
    return () => {
      clearTimeout(timerId);
    };
  }, [coolDownTime]);

  const handleRefresh = useCallback((): void => {
    mutate();
    setCoolDownTime(coolDownSeconds);
  }, [mutate, coolDownSeconds]);

  return { coolDownTime, handleRefresh };
};
